import { render, staticRenderFns } from "./upload_history.vue?vue&type=template&id=531efc28&scoped=true&"
import script from "./upload_history.vue?vue&type=script&lang=js&"
export * from "./upload_history.vue?vue&type=script&lang=js&"
import style0 from "./upload_history.vue?vue&type=style&index=0&id=531efc28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531efc28",
  null
  
)

export default component.exports